<template>
  <select
    class="sortOptionsWrapper"
    id="sortButtonControl"
    role="region"
    aria-labelledby="sortButtonID"
    ref="sortByPanel"
    v-model="selected"
    @change="onSelectChange(selected)"
  >
    <option value="default" disabled>{{ $t("Web.Containers.SortOrder.Title") }}</option>
    <option
      v-for="option in options"
      v-bind:key="option.key"
      v-bind:value="{
        key: option.key,
        displayName: option.displayName,
        type: option.type,
        isDescending: option.isDescending
      }"
    >
      {{
        $t("Web.Containers.SortOrder." + option?.displayName.replace(" ", ""))
      }}
    </option>
  </select>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, onUpdated, computed, Ref } from "vue";
import { SortOrderOption } from "../models/sortOrderOptions";
import vClickOutside from "click-outside-vue3";

export default defineComponent({
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    dropdownId: {
      type: String,
      required: false,
      default: "sortOrderDropdown"
    },
    label: {
      type: String,
      required: true,
      default: ""
    },
    options: {
      type: Array as PropType<SortOrderOption[]>,
      required: true,
      default: () => []
    },
    defaultSelected: {
      type: Object as PropType<SortOrderOption>,
      required: false,
      default: "default"
    }
  },
  setup(props, context) {
    const selectedOption: Ref<SortOrderOption> = ref(null);
    const selected: SortOrderOption = null;

    const displayLabel = computed(() => {
      if (selectedOption?.value && selectedOption.value.key !== "score") {
        return selectedOption.value.displayName;
      }
      return props.label;
    });

    const onSelectChange = (newValue: SortOrderOption) => {
      context.emit("sortOrderChange", newValue);
    };

    return {
      displayLabel,
      selectedOption,
      onSelectChange,
      selected: props.defaultSelected
    };
  }
});
</script>
